// @flow
export default () => ({
    submitButton: {
        position: 'relative',
        '&:only-child': {
            marginLeft: 'auto',
        },
    },
});
